import type { GetDishDetailResponse } from "api-types";

import { createContext, useContext } from "react";

/** Fetches what the menu response leaves out of one dish. */
export type DishDetailLoader = (
  dishId: string
) => Promise<GetDishDetailResponse>;

/** Null where the host app provides no loader. */
const DishDetailLoaderContext = createContext<DishDetailLoader | null>(null);

export const DishDetailLoaderProvider = DishDetailLoaderContext.Provider;
export const useDishDetailLoader = () => useContext(DishDetailLoaderContext);
